export interface ReduxDevToolsConfig<S> {
  name: string;
  initialState: S;
}

export const withReduxDevTools = <S>({ name, initialState }: ReduxDevToolsConfig<S>) => {
  const devTools =
    typeof window !== 'undefined' && (window as any)['__REDUX_DEVTOOLS_EXTENSION__']
      ? (window as any)['__REDUX_DEVTOOLS_EXTENSION__'].connect({ name })
      : false;

  if (devTools) devTools.init(initialState);

  return devTools;
};
